import React from "react";
import AppCard from "@crema/core/AppCard";
import Slider from "react-slick";
import PropTypes from "prop-types";
import BirthdaySlider from "./BirthdaySlider";
import BirthdaysItem from "./BirthdayItem";
import { Box, Typography } from "@mui/material";
const UpcomingBirthdays = ({ data }) => {
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,

        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <AppCard sxStyle={{ height: 1 }} title={"Today's Birthdays"}>
            <BirthdaySlider>
                <Slider className="slideRoot" {...settings}>
                    {data?.length > 0 ? (
                        data.map((data, index) => (
                            <BirthdaysItem
                                key={index}
                                icon={data.image}
                                bgColor="#9E49E6"
                                data={data}
                            />
                        ))
                    ) : (
                        <Box>
                            <Typography sx={{ textAlign: "center" }}>
                                No Birthdays Today...
                            </Typography>
                        </Box>
                    )}
                </Slider>
            </BirthdaySlider>
        </AppCard>
    );
};

export default UpcomingBirthdays;

UpcomingBirthdays.propTypes = {
    data: PropTypes.array,
};
